module.exports = __webpack_public_path__ + "media/Yipi_AnimacionWeb_06.0985ed50.mp4";